<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="center"><em>To Chris, Lucy and Leo,</em> <br/><em>Who made our Antipodean adventure a reality.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3d05f12c